import {useParams} from 'react-router-dom';
import ExamPage from './QuestionsPage';
import PreviewThanksPage from './PreviewThanksPage';
import ScorePreviewPage from './ScorePreviewPage';

const PreviewParamsPage = () => {
  const params: any = useParams();
  console.log('params', params.submodule_name);
  if (params.submodule_name) {
    switch (params.submodule_name) {
      case 'Questions':
        return <ExamPage />;
        break;
      case 'Thankyou':
        return <PreviewThanksPage />;
        break;
      case 'score':
        return <ScorePreviewPage />;
        break;
      default:
        return <PreviewThanksPage />;
    }
  }
};
export default PreviewParamsPage;
